import { useState, useEffect } from 'react'
import { api } from 'core/api/ConnectionManager'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'
import { defaultThemeStyles as defaultThemeDashboardStyles } from 'organisms/Dashboard/Dashboard-theme'

export interface DashboardScheduleStat {
    color: string
    label: string
    key: string
    value: number
}

type DashboardScheduleStatsResponse = Record<string, number>

const getColorForSchedules = (key: string) => {
    switch (key) {
        case 'today':
            return `var(--var-module-dashboard-component-dashboard-style-online, ${defaultThemeDashboardStyles.online})`
        case 'digitalSignageWithoutSchedule':
            return `var(--var-module-dashboard-component-dashboard-style-error, ${defaultThemeDashboardStyles.error})`
        default:
            return getThemeStyleValue('app', 'app', 'textMain') || defaultThemeStyles.textMain
    }
}

function DashboardScheduleMethods() {
    const [data, setScheduleStats] = useState<DashboardScheduleStat[] | null>(null)
    const [schedulesCount, setSchedulesCount] = useState(0)

    useEffect(() => {
        api.send<object, DashboardScheduleStatsResponse>(
            'dashboardGetScheduleStats',
            {},
            { showEmitError: false }
        ).then((response) => {
            const scheduleStats = Object.entries(response).map<DashboardScheduleStat>(([key, value]) => ({
                color: getColorForSchedules(key),
                label: `dashboard_${key}`,
                key,
                value,
            }))

            setScheduleStats(scheduleStats)
            setSchedulesCount(scheduleStats.reduce((count, item) => count + item.value, 0))
        })
    }, [])

    return {
        s_: {
            data,
            schedulesCount,
        },
    }
}

export default DashboardScheduleMethods
